'use client';

import 'swiper/css';
import 'swiper/css/pagination';

import { ThemeColorValueImportance } from '@actr/style/src/specs/theme-v2';
import { Text } from '@actr/ui/src/components/_atoms/text';
import { ContentBlock } from '@actr/ui/src/components/content-block';
import { Price } from '@actr/ui/src/components/price';
import { DecodeImageQuality, getDecodeImage } from '@actr/utilities/src/url/decode-image';
import React, { memo } from 'react';
import { Pagination } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';

import { PopularDirections } from '@/services/models/avia/country';
import ChannelDecoratedLink from '@/ui/channel-decorated-link';

import * as Styled from './style.css';

const CountryPopularDirections: React.FC<PopularDirections> = props => {
  const { title, list } = props || {};

  return (
    <ContentBlock className={Styled.ContentBlock} id="from_country_popular_directions">
      <Text tagName="h3" font="title.x2l">{title}</Text>
      <div className={Styled.CitiesContainer}>
        <div className={Styled.SwiperContainer}>
          <Swiper
            className={Styled.Swiper}
            slidesPerView="auto"
            pagination={{
              enabled: true,
              clickable: true
            }}
            modules={[Pagination]}>
            {
              list!.map((city, indexCity) => (
                <SwiperSlide key={indexCity}>
                  <div className={Styled.CityContainer}>
                    <img
                      className={Styled.CityImg}
                      src={getDecodeImage(city.city_img, DecodeImageQuality.Q30)}
                      alt={city.arrival_city_title}
                    />
                    <div className={Styled.CityInfo}>
                      <Text font="title.s">
                        { city.arrival_city_title.replace('Авиабилеты в', 'В') }
                      </Text>
                      <Text font="paragraph.xs" color={ThemeColorValueImportance.LIGHTER}>
                        Из города вылета
                      </Text>
                      {
                        city.departure_city_list.map((depCity, indexDepCity) => (
                          <div className={Styled.DepartureCity} key={indexDepCity}>
                            <Text>
                              { depCity.city_name }
                            </Text>
                            <ChannelDecoratedLink href={depCity.url}>
                              от
                              {' '}
                              <Price amount={depCity.min_price} extendColor={true} />
                            </ChannelDecoratedLink>
                          </div>
                        ))
                      }
                    </div>
                  </div>
                </SwiperSlide>
              ))
            }
          </Swiper>
        </div>
      </div>
    </ContentBlock>
  );
};

export default memo(CountryPopularDirections);
